module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/MODERN LANGUAGES-3cbfc87b94a99fe9026beb56c92a3ca6.png";